export class DataGridFilter {
  key;
  constructor({ key }) {
    console.warn(
      'TODO: DataGridFilter needs to be implemented, I imagine there will be a few different types that extend this model',
    );
    this.key = key;
  }
}
